import React from 'react'

const Conformation = () => {
  return (
    <div>Conformation</div>
  )
}

export default Conformation